import { defineMessages } from '@/i18n'

/** Built-in text of the shared building blocks (StatTile, Meter, SortableTable, BarChart). */
export const uiMessages = defineMessages({
  en: {
    vsPriorPeriod: 'vs prior period',
    noPriorPeriod: 'no prior period',
    noPlanRecorded: 'no plan recorded in AU',
    ofLimit: 'of {limit}',
    nothingToShow: 'Nothing to show.',
    viewChart: 'Chart',
    viewTable: 'Table',
    colLabel: 'Label',
    colValue: 'Value',
    noMatches: 'No matches',
    unnamed: '(unnamed)',
    showingFirst: 'Showing first {max} — keep typing to narrow.',
  },
  de: {
    vsPriorPeriod: 'ggü. Vorperiode',
    noPriorPeriod: 'keine Vorperiode',
    noPlanRecorded: 'kein Plan in AU erfasst',
    ofLimit: 'von {limit}',
    nothingToShow: 'Nichts anzuzeigen.',
    viewChart: 'Diagramm',
    viewTable: 'Tabelle',
    colLabel: 'Bezeichnung',
    colValue: 'Wert',
    noMatches: 'Keine Treffer',
    unnamed: '(ohne Namen)',
    showingFirst: 'Erste {max} — weitertippen zum Eingrenzen.',
  },
  cnr: {
    vsPriorPeriod: 'u odnosu na prethodni period',
    noPriorPeriod: 'nema prethodnog perioda',
    noPlanRecorded: 'plan nije unesen u AU',
    ofLimit: 'od {limit}',
    nothingToShow: 'Nema ničega za prikaz.',
    viewChart: 'Grafikon',
    viewTable: 'Tabela',
    colLabel: 'Oznaka',
    colValue: 'Vrijednost',
    noMatches: 'Nema pogodaka',
    unnamed: '(bez imena)',
    showingFirst: 'Prvih {max} — nastavi kucati da suziš.',
  },
  bs: {
    vsPriorPeriod: 'u odnosu na prethodni period',
    noPriorPeriod: 'nema prethodnog perioda',
    noPlanRecorded: 'plan nije unesen u AU',
    ofLimit: 'od {limit}',
    nothingToShow: 'Nema ničega za prikaz.',
    viewChart: 'Grafikon',
    viewTable: 'Tabela',
    colLabel: 'Oznaka',
    colValue: 'Vrijednost',
    noMatches: 'Nema pogodaka',
    unnamed: '(bez imena)',
    showingFirst: 'Prvih {max} — nastavi tipkati da suziš.',
  },
  sr: {
    vsPriorPeriod: 'u odnosu na prethodni period',
    noPriorPeriod: 'nema prethodnog perioda',
    noPlanRecorded: 'plan nije unesen u AU',
    ofLimit: 'od {limit}',
    nothingToShow: 'Nema ničega za prikaz.',
    viewChart: 'Grafikon',
    viewTable: 'Tabela',
    colLabel: 'Oznaka',
    colValue: 'Vrednost',
    noMatches: 'Nema pogodaka',
    unnamed: '(bez imena)',
    showingFirst: 'Prvih {max} — nastavi kucati da suziš.',
  },
})
